import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
interface Testimonial {
  quote: string;
  author: string;
  role: string;
  debtAmount: string;
}
const testimonials: Testimonial[] = [{
  quote: 'I was drowning in £180k of debt with HMRC breathing down my neck. Within 3 weeks, they found a buyer and I could finally sleep at night. The process was completely confidential and professional.',
  author: 'Anonymous',
  role: 'Former Construction Company Owner',
  debtAmount: '£180,000 in debts'
}, {
  quote: "After 15 years building my business, I had to face reality. The team handled everything discreetly and found a buyer who took on all the liabilities. I'm grateful I could walk away with dignity.",
  author: 'Anonymous',
  role: 'Former Retail Business Owner',
  debtAmount: '£95,000 in debts'
}, {
  quote: "The lease commitments were killing us. We couldn't afford the rent but couldn't get out of the contract. They found someone willing to take it all on. Honestly saved my sanity.",
  author: 'Anonymous',
  role: 'Former Restaurant Owner',
  debtAmount: '£120,000 in debts'
}];
export const Testimonials: React.FC = () => {
  return <div className="grid md:grid-cols-3 gap-8" data-id="element-186">
      {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 relative" data-id="element-187">
          <div className="absolute top-4 right-4 text-red-600 opacity-20" data-id="element-188">
            <QuoteIcon className="h-12 w-12" data-id="element-189" />
          </div>
          <div className="flex mb-3" data-id="element-190">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-191" />)}
          </div>
          <p className="text-gray-700 mb-4 italic relative z-10" data-id="element-192">
            "{testimonial.quote}"
          </p>
          <div className="border-t border-gray-200 pt-4" data-id="element-193">
            <p className="font-semibold text-gray-900" data-id="element-194">{testimonial.author}</p>
            <p className="text-sm text-gray-600" data-id="element-195">{testimonial.role}</p>
            <p className="text-sm text-red-600 font-medium mt-1" data-id="element-196">
              {testimonial.debtAmount}
            </p>
          </div>
        </div>)}
    </div>;
};